import { CLOCK_DIAMETER } from '../../consts/clockDimensions';

/**
 * The KlydoClock device app (clock-application-v3, Kotlin/Compose) authors
 * its info pages against a 1080px round clock face. In the studio the face
 * is rendered at `CLOCK_DIAMETER * scale`, so to match the device layout
 * exactly we express every dp/sp value as a fraction of the rendered face
 * diameter.
 */
const CLOCK_FACE_REFERENCE_PX = 1080;

export const clockFaceSize = (faceValue: number, scale: number): number =>
  (faceValue / CLOCK_FACE_REFERENCE_PX) * CLOCK_DIAMETER * scale;

/** Same conversion, returned as a `px` string for sx props. */
export const clockFacePx = (faceValue: number, scale: number): string =>
  `${clockFaceSize(faceValue, scale)}px`;
